<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2233_49273)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 6.2H15.5C18.151 6.2 20.3 8.34903 20.3 11C20.3 13.651 18.151 15.8 15.5 15.8H6.5C3.84903 15.8 1.7 13.651 1.7 11C1.7 8.34903 3.84903 6.2 6.5 6.2ZM0 11C0 7.41015 2.91015 4.5 6.5 4.5H15.5C19.0898 4.5 22 7.41015 22 11C22 14.5899 19.0899 17.5 15.5 17.5H6.5C2.91015 17.5 0 14.5899 0 11ZM6.5 7.5C4.567 7.5 3 9.067 3 11C3 12.933 4.567 14.5 6.5 14.5C8.433 14.5 10 12.933 10 11C10 9.067 8.433 7.5 6.5 7.5Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2233_49273">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
